import React, { Component } from 'react'
import errorImg from '../../assets/imgs/error-404.png';

class PageNotFound extends Component {
  render() {
    return (
      <div className='container container--indentVertical-xl container--center container--flex container--flexCenter'>
        <div>
          <div className="text text--bottom16">
            <img src={errorImg} alt="Страница не найдена" />
          </div>
          <div className='text text--h1 text--bottom16'>
            Ой! Эта страница потерялась
          </div>
          <div>
          <div className='text'>
            Но, возможно, вы найдете интересующую вас<br/> информацию в одном из разделов нашего сайта.
          </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/index.js